// ABOUTME: Which deployment the running app is, derived from the hostname
// ABOUTME: Single source of truth for environment-gated behaviour (Sentry, feature rollout)

export type AppEnvironment = "development" | "beta" | "alpha" | "staging" | "production"

/**
 * Derived from the hostname, because nothing else is trustworthy at runtime:
 * `BUILD_VERSION` is only `<date>.<sha>`, and CI's `STATE` never reaches Vite.
 * Each deployment is served from its own named subdomain, which does.
 *
 * Anything unrecognized is production. A new environment that forgets to name
 * itself here is therefore treated as the strictest case rather than quietly
 * being handed features meant for testing.
 */
export const resolveAppEnvironment = (hostname: string): AppEnvironment => {
  if (hostname === "localhost" || hostname.startsWith("127.") || hostname.endsWith(".local")) return "development"
  if (hostname.startsWith("beta.")) return "beta"
  if (hostname.startsWith("alpha.")) return "alpha"
  if (hostname.startsWith("staging.")) return "staging"
  return "production"
}

/** The environment this bundle is running in. */
export const appEnvironment: AppEnvironment = resolveAppEnvironment(
  typeof window !== "undefined" ? window.location.hostname : "",
)
